/* eslint-disable no-underscore-dangle */
import React from 'react'
import { Tooltip } from '@mui/material'
import { TreeView } from '@mui/x-tree-view/TreeView'
import { TreeItem } from '@mui/x-tree-view/TreeItem'
import { parseArrayKey, parseLeafValue, parseName, parseText } from '../utils'
import { ChevronDownIcon, ChevronRight, ExpandIcon } from 'lucide-react'

// const data = [{
//   id: 'root',
//   name: 'CPF: 70068611447',
// },
// {
//   id: 'RG',
//   name: 'RG: ',
//   children: [
//     {
//       id: '1',
//       name: 'Número: 2222',
//     },
//     {
//       id: '2',
//       name: 'UF: RN',
//     },
//   ],
// }]

// const useStyles = makeStyles({
//   root: {
//     // height: 110,
//     flexGrow: 1,
//     padding: 20,
//   },
//   treeRow: {
//     padding: 2,
//   },
// })

export default function ContentTree({ content, selectedPath }) {
  // const classes = useStyles()
  console.log({ content, selectedPath })

  function convertXMLJSONtoRecursiveNode(xmlJSON) {
    function getNodes(object, previousPath, previousParsedPath) {
      if (typeof object === 'string')
        return [
          {
            name: parseLeafValue(object, selectedPath),
            id: `${previousPath}.root`,
          },
        ]
      if (object._text)
        return [
          {
            name: parseLeafValue(object._text, selectedPath),
            id: `${previousPath}.root`,
          },
        ]

      const entries = Object.entries(object)
      const isArray = Array.isArray(object)

      return entries.map(([key, value]) => {
        const text = value._text
        const isChild = !!text
        const id = `${previousPath}.${key}`
        const paths = previousPath.split('.')
        const lastPath = paths[paths.length - 1]
        const parsedKey = isArray
          ? parseArrayKey({
              arrayIndex: key,
              childProps: value,
              path: lastPath,
            })
          : parseName(key)
        const parsedText = parseText(text, key)
        const currentParsedPath = `${previousParsedPath} > ${parsedKey}`

        const tooltipText = (
          <span style={{ fontSize: 14 }}>{currentParsedPath}</span>
        )
        const TheTooltip = ({ children }) => (
          <Tooltip
            enterNextDelay={2000}
            enterDelay={2000}
            arrow
            title={tooltipText}
          >
            {children}
          </Tooltip>
        )

        return isChild
          ? // ? { name: key + ": " + text, id }
            // : { name: key + ":", id, children: getNodes(value, id) }
            {
              name: (
                <div className>
                  <TheTooltip>
                    <b style={{ color: '#484848' }}>{parsedKey} </b>
                  </TheTooltip>
                  <span style={{ color: '#656565' }}>{parsedText}</span>
                </div>
              ),
              id,
            }
          : {
              name: (
                <div className>
                  <TheTooltip>
                    <b style={{ color: '#484848' }}>{parsedKey} </b>
                  </TheTooltip>
                </div>
              ),
              id,
              children: getNodes(value, id, currentParsedPath),
            }
      })
    }

    const root = xmlJSON
    const initialParsedPhath = selectedPath
      .split('.')
      .map((item) => parseName(item))
      .join(' > ')
    return getNodes(root, 'root', initialParsedPhath)
  }

  const data = convertXMLJSONtoRecursiveNode(content)

  console.log({ contentData: data })

  const renderTree = (nodes) => (
    <TreeItem key={nodes.id} nodeId={nodes.id} label={nodes.name}>
      {Array.isArray(nodes.children)
        ? nodes.children.map((node) => renderTree(node))
        : null}
    </TreeItem>
  )

  return (
    <TreeView
      defaultCollapseIcon={<ChevronDownIcon className="w-8 h-8" />}
      defaultExpanded={['root']}
      defaultExpandIcon={<ChevronRight className="w-8 h-8" />}
    >
      {data.map((root) => renderTree(root))}
    </TreeView>
  )
}
